import { useMutation } from '@tanstack/react-query'
import { generatePayment } from '../services'
import { CryptoInvoiceMutationKeys } from '../../keys'

import type { GeneratePaymentRequest } from '../../type'

export default function useMutationGeneratePayment() {
	return useMutation({
		mutationKey: [CryptoInvoiceMutationKeys.GeneratePayment],
		mutationFn: (payload: GeneratePaymentRequest) => generatePayment(payload),
	})
}
